<template>
  <header class="header-search">
    <nav class="header-search__filter" aria-label="header-search">
      <HTextfield
        v-model:value="search"
        type="search"
        :placeholder="placeholder"
        @update:value="searchMessage"
      />
      <WButton size="small" variant="tertiary" @click="clearFilter">
        Cancelar
      </WButton>
    </nav>
    <nav
      v-if="showResults"
      class="header-search__results"
      aria-label="search-controls"
    >
      <WButton
        icon-button
        variant="tertiary"
        class="header-search__button"
        icon="icChevronArrowUp"
        size="small"
        :disabled="disablePrevious"
        @click="highlightPrevious"
      />

      <WButton
        class="header-search__button"
        icon-button
        variant="tertiary"
        icon="icChevronArrowDown"
        size="small"
        :disabled="disableNext"
        @click="highlightNext"
      />

      {{ resultsLabel }}
    </nav>
  </header>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'
import debounce from 'lodash/debounce'

import { HTextfield } from '@/components/shared/atoms'

export default {
  components: {
    WButton,
    HTextfield
  },
  props: {
    highlightedMessage: {
      type: Number,
      required: true
    },
    filteredCount: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      search: '',
      showResults: false
    }
  },
  computed: {
    disablePrevious() {
      return this.highlightedMessage === this.filteredCount
    },
    disableNext() {
      return this.highlightedMessage <= 1
    },
    resultsLabel() {
      if (this.highlightedMessage) {
        return [
          this.highlightedMessage,
          'de',
          this.filteredCount,
          this.filteredCount === 1 ? 'resultado' : 'resultados'
        ].join(' ')
      }

      return 'Nenhum resultado encontrado'
    },
    placeholder() {
      return this.loading ? 'Carregando mensagens...' : 'Buscar na conversa'
    }
  },
  methods: {
    searchMessage: debounce(async function () {
      this.showResults = false

      if (!this.search) {
        this.$store.commit('pillars/channel/message/clearFilteredMessages')
        return
      }

      await this.$store.dispatch(
        'pillars/channel/message/setFilteredMessages',
        this.search
      )
      this.highlightPrevious()
      this.showResults = true
    }, 700),
    clearFilter() {
      this.search = ''
      this.$store.commit('pillars/channel/message/clearFilteredMessages')
      this.$store.commit('ui/channel/setSearchMessage', false)
    },
    highlightPrevious() {
      this.$store.commit('pillars/channel/message/highlightPrevious')
    },
    highlightNext() {
      this.$store.commit('pillars/channel/message/highlightNext')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.header-search {
  &__filter {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    height: calc(var(--filter-header-height) - 1px);
    gap: var(--gl-spacing-02);
  }

  &__results {
    @extend %body-small;
    display: flex;
    align-items: center;
    color: var(--sys-color-content-primary);
    padding: 0 0 var(--gl-spacing-02) 0;

    &__button {
      padding: var(--gl-spacing-01) !important;

      &:last-of-type {
        margin-right: var(--gl-spacing-03);
      }
    }
  }
}
</style>
